import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import NotFound from '../layouts/NotFound/NotFound';
import { EnvironmentService } from '../services/Environment.service';


function CheckStates({ league, user, children }) {
  const history = useHistory();
  const location = useLocation();

  // Check if player needs to update details
  const needsDetailsUpdate = user?.player?.status === 'needs_details_update';

  let statesOK = league !== null && league !== undefined
  if ( ['/leagues','/update-details'].includes(location.pathname) ) {
    statesOK = true
  }

  React.useEffect(() => {
    // Redirect if player needs to update details
    if (needsDetailsUpdate) {
      history.push('/update-details');
      return;
    }
    
    if (!statesOK) {

      history.push('/redirect');
    }
  }, [league, statesOK, history, needsDetailsUpdate]);


  return <>{statesOK ? children : null}</>;
}

export default CheckStates;
